import { DELETE_DMX_CONTROLLER, DELETE_DMX_CONTROLLER_SUCCESSFUL, DELETE_DMX_CONTROLLER_FAILED } from './actionTypes';

export const deleteDmxController = (controller) => {
  return {
    type: DELETE_DMX_CONTROLLER,
    payload: { controller },
  };
};

export const deleteDmxControllerSuccessful = (message) => {
  return {
    type: DELETE_DMX_CONTROLLER_SUCCESSFUL,
    payload: message,
  };
};

export const deleteDmxControllerFailed = (message) => {
  return {
    type: DELETE_DMX_CONTROLLER_FAILED,
    payload: message,
  };
};
